(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('UserTypeAddController', UserTypeAddController);

    /* @ngInject */
    function UserTypeAddController($q, logger,
        userTypeService, userCategoryService,
        $uibModalInstance, WizardHandler, $timeout,
        applicationService, currentUser, $filter) {

        var vm = this;
        vm.title = 'Add User Type';
        vm.userType = userTypeService.getDefaultUserType();
        vm.userCategories = [];
        vm.applications = [];
        vm.valid = false;
        vm.currentStep = null;
        vm.togglableRoles = [];

        vm.save = save;
        vm.reset = reset;
        vm.refresh = refresh;
        vm.wizardPrevious = wizardPrevious;
        vm.wizardNext = wizardNext;
        vm.onApplicationPermissionsChanged = onApplicationPermissionsChanged;
        vm.onApplicationEdit = verifyApplicationEditStatus;
        vm.onApplicationSave = verifyApplicationEditStatus;

        activate();

        function activate() {
            var promises = [getUserCategories(), getAllApplications()];
            return $q.all(promises).then(function () {
                setForm(vm.userCategories);
                onTruckAccessChange(vm.userType.display.TruckLimit);
            });
        }

        function save() {
            var model = mapModel(vm.userType);
            userTypeService.saveUserType(model)
                .then(function (result) {
                    if (result.status === 200) {
                        $uibModalInstance.close(result.data);
                    } else {
                        logger.info('Error saving user category');
                    }

                });

        }

        function mapModel(userType) {
            var defaultApplications = [];
            angular.forEach(userType.defaultApps, function (app) {
                defaultApplications.push({
                    ApplicationId: app.ApplicationId,
                    HasAccess: app.HasAccess,
                    Roles: app.SelectedRoles.map(function (role) {
                        return role.RoleId;
                    })
                });
            });

            return {
                UserTypeId: userType.basic.UserTypeId,
                UserTypeName: userType.basic.UserTypeName,
                UserCategoryId: userType.basic.UserCategoryId,
                Level: userType.basic.Level,
                IsADUser: userType.display.IsADUser,
                CanViewOrganization: userType.display.CanViewOrganization,
                CanViewAllTrucks: userType.display.TruckLimit === 0,
                CanViewCustomerTrucks: userType.display.TruckLimit === 1,
                CanViewLimitedTrucks: userType.display.TruckLimit === 2,
                CanCreateUser: userType.create.CanCreateUser,
                CanCreateOutsideCategory: userType.create.CanCreateOutsideCategory,
                CanViewAllApplications: userType.create.CanViewAllApplications,
                CanModifyApplicationRoles: userType.create.CanModifyApplicationRoles,
                DefaultApplications: defaultApplications,
                Active: userType.Active
            };
        }

        function reset() {
            vm.userTypeBasicForm.options.resetModel();
            vm.userTypeDisplayForm.options.resetModel();
            vm.userTypeCreateForm.options.resetModel();
            $uibModalInstance.dismiss('cancel');
        }

        function setForm(userCategories) {
            vm.userTypeBasicFields = userTypeService.getUserTypeBasicFields(1, userCategories, onValidate);
            vm.userTypeDisplayFields = userTypeService.getUserTypeDisplayFields(onTruckAccessChange);
            vm.userTypeCreateFields = userTypeService.getUserTypeCreateFields(onToggleChange);
        }

        function onValidate(isValid) {
            vm.valid = isValid;
        }

        function onToggleChange(id, value) {
            if (id === 'CanCreateUser') {
                vm.userTypeCreateFields[1].templateOptions.disabled = !value;
                vm.userTypeCreateFields[2].templateOptions.disabled = !value;
                vm.userTypeCreateFields[3].templateOptions.disabled = !value;

                if (!value) {
                    vm.userType.create.CanCreateOutsideCategory = false;
                    vm.userType.create.CanViewAllApplications = false;
                    vm.userType.create.CanModifyApplicationRoles = false;
                    removeTogglableRole('Create_User');
                }

                if (value) {
                    addTogglableRole('Create_User');
                }
            }
        }

        function onTruckAccessChange(value) {
            var truckSpecificRoles = ['All_Trucks', 'Customer_Full', 'Customer_Limit'];
            var roleNameToBeAdded = truckSpecificRoles[value];
            var rolesToBeRemoved = _.reject(truckSpecificRoles, function (roleName) {
                return roleName === roleNameToBeAdded;
            });

            addTogglableRole(roleNameToBeAdded);
            angular.forEach(rolesToBeRemoved, function (role) {
                removeTogglableRole(role);
            });
        }

        function removeTogglableRole(roleName) {
            var application = _.find(vm.applications, { ShortName: 'SSO' });
            if (application) {
                if (application.access) {
                    application.selectedRoles = _.reject(application.selectedRoles, function (role) {
                        return role.RoleName === roleName;
                    });

                    if (!application.selectedRoles.length) {
                        application.access = false;
                    }
                }               
            }

            removeTogglablerRoleFromPermissions(roleName);
        }

        function removeTogglablerRoleFromPermissions(roleName) {
            var application = _.find(vm.userType.defaultApps, { ShortName: 'SSO' });
            if (application) {
                if (application.HasAccess) {
                    application.SelectedRoles = _.reject(application.SelectedRoles, function (role) {
                        return role.RoleName === roleName;
                    });

                    if (!application.SelectedRoles.length) {
                        application.HasAccess = false;
                    }
                }
            }
        }
        
        function addTogglableRole(roleName) {
            var application = _.find(vm.applications, { ShortName: 'SSO' });
            if (application) {
                if (!application.access) {
                    application.access = true;
                }

                var hasRole = _.find(application.selectedRoles, { RoleName: roleName });
                if (!hasRole) {
                    var roleToAdd = getTogglableRole(roleName);
                    if (roleToAdd) {
                        application.selectedRoles.push(roleToAdd);
                        addTogglableRoleFromPermissions(roleName, roleToAdd, application);
                    }                    
                }
            }           
        }

        function addTogglableRoleFromPermissions(roleName, roleToAdd, app) {
            var application = _.find(vm.userType.defaultApps, { ShortName: 'SSO' });
            if (!application) {
                application = {
                    ApplicationId: app.ApplicationId,
                    ApplicationName: app.ApplicationName,
                    ShortName: app.ShortName,
                    HasAccess: true,
                    SelectedRoles: []
                };
                
                application.SelectedRoles.push(roleToAdd);                

                vm.userType.defaultApps.push(application);
            } else {
                if (!application.HasAccess) {
                    application.HasAccess = true;
                }

                var hasRole = _.find(application.SelectedRoles, { RoleName: roleName });
                if (!hasRole) {
                    application.SelectedRoles.push(roleToAdd);
                }
            }
        }

        function getTogglableRole(roleName) {
            return _.find(vm.togglableRoles, { RoleName: roleName });
        }

        function getUserCategories() {
            return userCategoryService.getUserCategories().then(function (results) {
                vm.userCategories = results;
            });
        }

        //hack to make the multiple selects update the input width
        function refresh() {
            $timeout(function () { }, 50);
        }

        function wizardPrevious() {
            refresh();
            WizardHandler.wizard('userTypeWizard').previous();
        }

        function wizardNext() {
            refresh();
            WizardHandler.wizard('userTypeWizard').next();
        }

        function onApplicationPermissionsChanged(application) {
            var appPerms = $filter('filter')(vm.userType.defaultApps,
                { ApplicationId: application.ApplicationId }, true);
            if (appPerms.length > 0) {
                appPerms[0].HasAccess = application.HasAccess;
                appPerms[0].SelectedRoles = application.SelectedRoles;
            } else {
                vm.userType.defaultApps.push(application);
            }
        }

        function verifyApplicationEditStatus() {
            var editedApps = _.where(vm.applications, { edited: true });
            if (editedApps.length > 0) {
                onValidate(false);                
            } else {
                onValidate(true);               
            }
        }

        function getAllApplications() {
            var query;

            query = applicationService.getAllApplications();

            return query
                .then(function (result) {
                    angular.forEach(result, function (item) {
                        item.access = false;
                        item.edited = false;
                        item.selectedRoles = [];
                        item.canViewRoles = true;
                        
                        if (item.ShortName === 'SSO') {
                            var createUserRole = _.find(item.Roles, { RoleName: 'Create_User' });
                            if (createUserRole) {
                                vm.togglableRoles.push(angular.copy(createUserRole));
                            }

                            var allTrucksRole = _.find(item.Roles, { RoleName: 'All_Trucks' });
                            if (allTrucksRole) {
                                vm.togglableRoles.push(angular.copy(allTrucksRole));
                            }

                            var customerFullRole = _.find(item.Roles, { RoleName: 'Customer_Full' });
                            if (customerFullRole) {
                                vm.togglableRoles.push(angular.copy(customerFullRole));
                            }

                            var customerLimitRole = _.find(item.Roles, { RoleName: 'Customer_Limit' });
                            if (customerLimitRole) {
                                vm.togglableRoles.push(angular.copy(customerLimitRole));
                            }
                        }                        
                      
                        item.original = {
                            access: item.access,
                            selectedRoles: item.selectedRoles,
                            edited: item.edited
                        };
                    });

                    vm.applications = result;
                });
        }

    }
})();
